export default __webpack_public_path__ + "static/media/vimeo.37a2bdfb.svg";